<template>
  <div>
    <header class="formWidgetHeader">
      <div class="widgetHeaderWrapper">
        <div class="formNavGroup navGroupLeft">
          <router-link :to="{ name: 'offtaker.accountSetupTwo' }"
                       class="navGroupItem formClose"
                       title="Skip this Setup">
            Skip
          </router-link>
          <router-link :to="{ name: 'offtaker.accountSetupTwo' }"
                       title="Previous Step"
                       class="navGroupItem navBack hidden">
            <svg class="cust_icon"
                 viewBox="0 0 30 30"
                 fill="none"
                 fill-rule="evenodd"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                    d="M10.575 13.9394L9.51447 14.9999L18 23.4854L20.121 21.3644L13.758 14.9999L20.121 8.6354L18 6.5144L10.575 13.9394Z" />
            </svg>
          </router-link>
        </div>
        <div class="formNavGroup navGroupCenter">
          <div class="navGroupItem formTitle">
            <h4 class="title font-bold caps_upper">Setup your account</h4>
          </div>
        </div>
        <div class="formNavGroup navGroupRight">
          <submit-button class="navGroupItem formSubmit"
                         :disabled="selectedCropIds.length === 0"
                         @click="submitCrop"
                         :loading="submitting">
            Next
          </submit-button>
        </div>
      </div>
    </header>

    <main class="mainContentArea">
      <div class="formWidgetWrapper row no-gutters">
        <section class="formWidgetbody bg__white col-md-9 col-lg-8">
          <div class="container form_body">
            <div
                 class="section_header font-md margin_top_lg margin_bottom_lg pb-3">
              <h4 class="title_md color__black font-bold">Select Crops</h4>
            </div>
            <div class="section_body loading">
              <loading v-if="gettingCrops" />
              <div class="row">
                <crop-row v-for="(crop, index) in crops"
                          :key="index"
                          :crop="crop"
                          @selectedCrop="selectedCrop" />
              </div>
            </div>
          </div>
        </section>

        <aside class="formWidgetProgress col-md-3 col-lg-4">
          <div class="verticalProgressMarkers">
            <div class="progressMarkerItem active ">
              <div class="step_line">
                <div class="stepDetails">
                  <span class="stepNode"></span>
                  <div class="stepInfo">
                    <h4 class="title font-bold margin_bottom_sm">
                      1. Select Crops
                    </h4>
                    <p>
                      Select the crops you are interested in, and we’ll help you
                      find the best sellers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="progressMarkerItem">
              <div class="step_line">
                <div class="stepDetails">
                  <span class="stepNode"></span>
                  <div class="stepInfo">
                    <h4 class="title font-bold margin_bottom_sm">
                      2. Setup your profile
                    </h4>
                    <p>
                      Setup your aggregator profile, to get found by investors
                      and off-takers interested in your inventory.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </main>
  </div>
</template>

<script>
import CropRow from "@/components/off-taker/CropRow";

export default {
  data() {
    return {
      gettingCrops: false,
      crops: [],
      selectedCropIds: [],
      submitting: false
    };
  },
  methods: {
    getCrops() {
      this.gettingCrops = true;
      this.$http
        .get("farm_crops/names")
        .then(response => {
          this.$log(response.data);
          this.crops = response.data;
        })
        .catch(error => {
          this.$toastr.error(error);
        })
        .finally(() => {
          this.gettingCrops = false;
        });
    },
    selectedCrop(crop) {
      if (this.selectedCropIds.length === 0) {
        this.selectedCropIds.push(crop.id);
      } else {
        const cropIndex = this.selectedCropIds.findIndex(
          item => item === crop.id
        );
        if (cropIndex !== -1) {
          this.selectedCropIds.splice(cropIndex, 1);
        } else {
          this.selectedCropIds.push(crop.id);
        }
      }
    },
    submitCrop() {
      this.submitting = true;
      this.$http
        .post("off_takers/crops", {
          crops: this.selectedCropIds
        })
        .then(response => {
          this.$log(response);
          this.$router.push({
            name: "offtaker.accountSetupTwo"
          });
        })
        .catch(error => {
          this.$toastr.error(error);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    getUserCrops() {
      this.submitting = true;
      this.$http
        .get("off_takers/crops")
        .then(response => {
          this.$log("User crops ", response);
        })
        .catch(error => {
          this.$toastr.error(error);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  created() {
    this.getCrops();
    // this.getUserCrops();
  },
  components: {
    CropRow
  }
};
</script>

<style></style>
